<label class="switch">
    <input type="checkbox" (input)="onToggled()" [checked]="toggled">
    <span class="slider round"></span>
</label>
